﻿import { AnyElement } from "mu-widget/lib/MuWidget";
import { BaseWidget } from "../BaseWidget";
import { CForms } from "../Generated/CClasses";
import { MessageList, MessagePath } from "../Types";
import { UiErrorList } from "./UiErrorList";
import { UiFlashItem } from "./UiFlash";
import { UiLoginInfo } from "./UiLoginInfo";
import { VVZLogin } from "./VVZLogin";
import { DialogButton, UiDialog } from "./UiDialog";

export class BaseForm extends BaseWidget {

    public formCode : string;

    public formAccountEmail : string;

    public backend = new CForms();
    
    public uidt: string = "";

    public vvzLogin : VVZLogin;
    
    public lastErrorsMessage: UiFlashItem | null;

    public onVVZSuccess: EOnVVZResult = "FlashMessage";

    public onVVZFailed: EOnVVZResult = "FlashMessage";

    public onVVZSuccessUrl: string|null = null;

    public onVVZFailedUrl: string|null = null;

    public backText: string|null = "Zpět do aplikace";

    public backUrl: string|null = null;

    public autoPublishToVVZ: boolean = false;

    public errorList: UiErrorList;

    public bSave_click() { }

    beforeIndex(): void {
        this.muAppendContent(/* html */`<div mu-widget="UiErrorList" mu-template="errorList"></div>`);
    }

    public override async afterIndex() {
        super.afterIndex();
        this.vvzLogin = new VVZLogin();
        this.vvzLogin.backend = this.backend;
        setTimeout(() => this.showErrors([]), 300);
        if (this.uidt) {
            this.loadFormContent();
        }
        const loginInfo = this.getLoginInfo();
        loginInfo.backend = this.backend;
        loginInfo.formAccountEmail = this.formAccountEmail;
        if (this.ui.bBackToApp) this.muVisible(!!this.backUrl, "bBackToApp");

        if (this.autoPublishToVVZ) {
            setTimeout(async() => {
                // Automatické přihlášení nebude fungovat protože okno otevřené při onloadu prohlížeč blokuje
                /* await loginInfo.refresh(true);
                if (!loginInfo.isLogged()) {
                    await loginInfo.doLogin();
                } */
                await this.publish();
            }, 100);
        }

        this.muParent.muOnAfterIndex.push(() => this.errorList = this.muParent.muNamedWidget.errorList as UiErrorList)
        this.handleScroll();
        this.setupInputLengthValidations();
    }

    protected getLoginInfo(): UiLoginInfo {
        return this.muNamedWidget.loginInfo as unknown as UiLoginInfo;
    }

    public openDialog(
        title: string,
        message: string,
        buttons: DialogButton[]
    ): { promise: Promise<any>, ui: UiDialog } {
        const ui = this.muWidgetFromTemplate("dialog", this.container, {
            title, message, buttons
        }) as unknown as UiDialog;

        return {
            promise: ui.getPromise(),
            ui
        };
    }

    private setupInputLengthValidations() {
        document.querySelectorAll('input[type="number"]').forEach(el => {
            let charLimit: number = 0;
            const input: HTMLInputElement = el as HTMLInputElement;
            if (input.max !== "") {
                charLimit = input.max.length;
            } else {
                charLimit = input.maxLength;
            }

            el.addEventListener('input', () => {
                if (input.value.length > charLimit && charLimit !== -1) {
                    input.value = input.value.slice(0, charLimit);
                }
            });
        })
    }

    private handleScroll() {
        const body = document.body;
        const html = document.documentElement;
        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);

        if (this.ui.bUp != null) this.ui.bUp.addEventListener("click", () => (document.querySelector(".form-page.form-row--mb1ex") as AnyElement).scrollIntoView());
        if (this.ui.bDown != null) this.ui.bDown.addEventListener("click", () => (document.querySelector('[mu-id="lastElement"]') as AnyElement).scrollIntoView());
    }

    public bShowJSON_click() {
        const data = this.muFetchData();
        this.ui.jsonImport.value = this.ui.log.innerText = JSON.stringify(data, null, 4);
    }

    public bShowXML_click() {
        const data = this.muFetchData();
        const prom = this.backend.ShowXML(this.formCode, data);
        prom.then((res) => {
            this.ui.log.innerText = res.Xml;
            if (res.Errors) this.showErrors(res.Errors);
            if (res.XmlWarnings) this.muNamedWidget.xmlWarnings.muBindData(res.XmlWarnings);
        }).catch(exc => {
            this.ui.log.innerText += JSON.stringify(exc, null, 4);
        });
    }

    public bImportJSON_click() {
        this.muBindData(JSON.parse((this.ui.jsonImport as HTMLTextAreaElement).value));
    }

    public bCheckVVZ_click() {
        this.procVVZ("validate");
    }

    protected async procVVZ(operation: "publicate"|"validate") {
        const data = this.muFetchData();
        try {
            let res;
            switch(operation) {
                case "publicate":
                    res = await this.backend.PublicateOnVVZ(this.formCode, data);
                    break;
                case "validate":
                    res = await this.backend.ValidateOnVVZ(this.formCode, data);
                    break;
            }
            this.ui.log.innerText = res.Xml + "\n\n\n" + res.VVZResponse;
            if (res.Errors) this.showErrors(res.Errors);
            if (res.XmlWarnings) this.muNamedWidget.xmlWarnings.muBindData(res.XmlWarnings);
            // if (res.XmlWarnings) this.muNamedWidget.reqWarnings.muBindData(res.ReqWarnings);
            if (res.PublicateResponse) this.ui.pubResult.innerText = JSON.stringify(res.PublicateResponse, null, 4);
        }
        catch(exc) {
            this.ui.log.innerText = JSON.stringify(exc, null, 4);
        }
    }

    public bSendVVZ_click() {
        this.procVVZ("publicate");
    }

    public showErrors(messageList: MessageList): UiFlashItem|null {
        // Vyčistit existující
        var allErrorLabels = this.container.querySelectorAll('[mu-for^="error:"]');
        var allErrorElements = this.container.querySelectorAll('.is-invalid');
        for(const el of allErrorLabels)
            this.clearError(el as AnyElement);
        for (const el of allErrorElements)
            this.removeErrorClasses(el as AnyElement);
        if (messageList.length > 0) {
            //const wFlashItem = this.addFlash("Formulář obsahuje chyby", "error");
            const errorContainer: HTMLElement | null = document.querySelector(".static-error");
            if (errorContainer != null) {
                if (errorContainer.classList.contains("hidden")) errorContainer.classList.remove("hidden");
                if (errorContainer.classList.contains("centered")) setTimeout(() => errorContainer.classList.remove("centered"), 1000);
            }
            const errorList = this.errorList; // this.muWidgetFromTemplate('errorList', wFlashItem.ui.extraContent) as unknown as UiErrorList;
            errorList.clear();
            for(const message of messageList) {
                const el = this.findElementByPath(message.Path);
                if (!el) {
                    console.log("No element on path '" + message.Path.join("/"));
                    errorList.add(message.Message, null);
                    continue;
                } 
                let ell = ((el as any) as WithErrorLabel).errorLabel;
                if (ell == null) {
                    el.classList.add("is-invalid");
                    this.findTagElementParent(el as HTMLElement, "div").classList.add("has-error");
                    ell = document.createElement("div");
                    ell.className = "error-list";
                    ell.setAttribute("mu-for", "error:" + el.getAttribute("mu-bind"));
                    const elb = el.nextElementSibling;
                    if (elb) el.parentElement.insertBefore(ell, elb);
                    else el.parentElement.appendChild(ell);
                    ((el as any) as WithErrorLabel).errorLabel = ell;
                }
                this.addError(ell, message.Message);
                errorList.add(message.Message, el);
            }
            return null;
        } else {
            this.errorList.clear();
            if (document.querySelector(".static-error") != null) {
                document.querySelector(".static-error").classList.add("hidden");
                setTimeout(() => document.querySelector(".static-error").classList.add("centered"), 1000);
            }
        }
        return null;
    } 
    //todo: add/clear
    public clearError(el : AnyElement) {
        el.innerHTML = "";
        this.muVisible(false, el);
    }

    public removeErrorClasses(el: AnyElement) {
        el.classList.remove("is-invalid");
        this.findTagElementParent(el as HTMLElement, "div").classList.remove("has-error");
    }

    public addError(el : AnyElement, message : string) {
        const mel = document.createElement("div");
        mel.className = "error-item";
        mel.innerText = message;
        el.appendChild(mel);
        this.muVisible(true, el);
    }

    // PROD

    async bValidate_click() {
        this.validate();
    }

    bPublish_click() {
        this.publish();
    }

    bSaveConcept_click() {
        this.saveConcept();
    }

    async saveConcept(): Promise<boolean> {
        const res = await this.backend.SaveFormContent(this.uidt, this.muFetchData());
        const messages = {
            saved: "Koncept uložen",
            nochange: "Údaje se nezměnily",
            failed: "Nepodařilo se uložit",
        }
        this.addFlash(messages[res]);
        return res;
    }

    async loginPrompt() {
        if (!this.isLogged()) {
            if (await this.openDialog(
                "Je potřeba se přihlásit do věstníku.", "Chcete se nyní přihlásit",
                [
                    { title: "Ano přihlásit", value: true },
                    { title: "Ne", value: false },
                ]).promise) {
                await this.getLoginInfo().doLogin();
            }
        }
    }

    async validate() {
        await this.loginPrompt();
        if (this.isLogged()) {
            // const res = await this.backend.ValidateOnVVZ(this.formCode, this.muFetchData());
            const res = await this.backend.ValidateVVZ(this.uidt, this.muFetchData());
            if (this.lastErrorsMessage != null) this.lastErrorsMessage.remove();
            /* if (res.Errors?.length > 0) this.addFlash("Formulář obsahuje chyby.")
            else this.addFlash("Formulář je v pořádku."); */
            if (!res.Errors?.length) this.addFlash("Formulář je v pořádku.");
            this.lastErrorsMessage = this.showErrors(res.Errors || []);
        } else {
            this.addFlash("Nejprve se přihláste do věstníku.");
        }
    }

    async publish() {
        await this.loginPrompt();
        if (this.isLogged()) {
            if (await this.saveConcept()) {
                const res = await this.backend.PublicateVVZ(this.uidt, this.muFetchData());
                if (this.lastErrorsMessage != null) this.lastErrorsMessage.remove();
                this.lastErrorsMessage = this.showErrors(res.Errors);

                if (res.PublicateResponse?.Success) {
                    this.addFlash("Formulář byl vypublikován.");
                    this.loadFormContent();
                    switch (this.onVVZSuccess) {
                        case "Dialog":
                            if (await this.openDialog(
                                "Formulář byl vypublikován", "Co chcete udělat teď?",
                                [
                                    { title: this.backText || "Vrátit se do aplikace", value: true },
                                    { title: "Zůstat zde", value: false },
                                ]
                                ).promise
                            ) {
                                document.location.href = (this.onVVZSuccessUrl || this.backUrl);
                            }
                            break;
                        case "Redirect":
                            document.location.href = (this.onVVZSuccessUrl || this.backUrl);
                            break
                    }
                } else {
                    this.addFlash("Nepodařilo se vypublikovat formulář.", "error");
                    switch (this.onVVZFailed) {
                        case "Dialog":
                            if (await this.openDialog(
                                "Nepodařilo se vypublikovat formulář", "Co chcete udělat teď?",
                                [
                                    { title: "Opravit údaje a zkusit znovu", value: false },
                                    { title: this.backText || "Vrátit se do aplikace", value: true },
                                ]
                                ).promise
                            ) {
                                document.location.href = (this.onVVZFailedUrl || this.backUrl);
                            }
                            break;
                        case "Redirect":
                            document.location.href = (this.onVVZFailedUrl || this.backUrl);
                            break
                    }
                }
            }
        } else {
            this.addFlash("Nejprve se přihláste do věstníku.");
        }
    }

    isLogged(): boolean {
        return (this.muNamedWidget.loginInfo as unknown as UiLoginInfo).isLogged();
    }

    async loadFormContent() {
        const data = await this.backend.GetFormContentAndUser(this.uidt);
        const state = data.FormContent.DTPublicatedTED 
            ? "inTED"
            : (data.FormContent.DTPublicatedVVZ
                ? "inVVZ"
                : "concept");

        const stateTexts = {
            concept: "Koncept",
            inVVZ: "Uveřejněno ve VVZ",
            inTED: "Uveřejněno v TED"
        }

        this.muBindData({
            ...data.FormContent.Content || {},
            DTCreated: data.FormContent.DTCreated,
            DTPublicatedVVZ: data.FormContent.DTPublicatedVVZ,
            DTPublicatedTED: data.FormContent.DTPublicatedTED,
            stateText: stateTexts[state]
        });

        this.muVisible(state == "concept", ["pActions"])
    }

    async bLogin_click() {
        console.log(await this.vvzLogin.login());
    }

    bLogout_click() {
        
    }

	bBackToApp_click() {
		document.location.href = this.backUrl;
	}
}

type WithErrorLabel = { errorLabel : AnyElement };

export type EOnVVZResult = "FlashMessage" | "Dialog" | "Redirect";

